import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { formatDate, Page, State } from '../components';
interface Audit {
  id: string;
  action: string;
  targetType: string;
  targetId?: string;
  actorUserId?: string;
  createdAt: string;
}
export function AuditPage() {
  const query = useQuery({
    queryKey: ['audit'],
    queryFn: () => api<{ data: Audit[] }>('/api/v1/audit-logs'),
  });
  return (
    <Page title="Audit log" description="Sensitive tenant mutations are recorded here.">
      <State loading={query.isLoading} error={query.error} empty={query.data?.data.length === 0}>
        <div className="card table-scroll">
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Target</th>
                <th>Actor</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {query.data?.data.map((row) => (
                <tr key={row.id}>
                  <td>
                    <code>{row.action}</code>
                  </td>
                  <td>
                    {row.targetType}
                    {row.targetId ? ` · ${row.targetId}` : ''}
                  </td>
                  <td>{row.actorUserId ?? 'System'}</td>
                  <td>{formatDate(row.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </State>
    </Page>
  );
}
